import { parse } from 'hub-http/helpers/params';
export const getGatesWithUrlOverrides = gates => {
  const {
    gates: overrideGates
  } = parse(window.location.search.slice(1));
  if (!overrideGates) {
    return gates;
  }
  return [gates, overrideGates].flat();
};